export class Products {
  self = null;
  brandId = '';

  constructor(brandId, _this) {
    this.self = _this;
    this.brandId = brandId;
  }

  /**
   * Obtiene un producto por su ID
   *
   * @param {*} product_id 
   * @param {*} price_id 
   * @return 
   * @memberof Products
   */
  getPrice(product_id, price_id) {

    // Iteramos sobre los productos
    for (let product of this.self.user.current_user.products) {
      if (product.id == product_id) {

        // Iteramos sobre los precios
        for (let price of product.prices) {
          if (price.id == price_id) {
            return price;
          }
        }
      }
    }

    return false;
  }

  /**
   * Devuelve el precio a mostrar para este usuario
   *
   * @param {*} product_id 
   * @param {*} price_id 
   * @return 
   * @memberof Products
   */
  getPriceAmount(product_id, price_id) {
    let price = this.getPrice(product_id, price_id);
    if (!price) {
      return false;
    }

    // Iteramos sobre los amounts para ver si tenemos nuestra moneda
    var usdAmount = 0;
    for (let amount of price.amounts) {
      if (amount.currency == this.self.user.current_user.currency) {
        return [amount.amount, amount.currency];
      }

      if (amount.currency == 'USD') {
        usdAmount = amount.amount;
      }
    }

    // Si no tenemos nuestra moneda, miramos si teníamos USD
    if (usdAmount) {
      return [usdAmount, 'USD'];
    }

    // Si no, devolvemos la primera
    return [price.amounts[0].amount, price.amounts[0].currency];

  }


  /**
   * Devuelve el título del precio
   *
   * @param {*} product_id 
   * @param {*} price_id 
   * @return 
   * @memberof Products
   */
  getPriceTitle(product_id, price_id) {
    let price = this.getPrice(product_id, price_id);
    if (!price) {
      return false;
    }

    return price.title;
  }

  getProductPrices(id) {
    id = Number.parseInt(id);

    // Recorremos los productos en el user    
    for (let product of this.self.user.current_user.products) {
      if (parseInt(product.id) == id) {
        return product.prices;
      }
    }

    return [];

  }

  getPrice(product_id, price_id) {
    product_id = Number.parseInt(product_id);
    price_id = Number.parseInt(price_id);

    // Recorremos los productos en el user
    for (let product of this.self.user.current_user.products) {
      if (parseInt(product.id) == product_id) {
        for (let price of product.prices) {
          if (parseInt(price.id) == price_id) {
            return price;
          }
        }
      }
    }

    // Si no lo encontramos, devolvemos false
    return false;
  }

}